import React, { type MouseEventHandler } from "react"
import styled from "styled-components"
import { Icon, Text } from "@autouncle/ui"
import ChevronLeft from "@autouncle/icons/dist/assets/chevron-left.svg?react"

const HeaderContainer = styled.div`
  display: flex;
  height: 72px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
`

const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
  flex-shrink: 0;
  height: var(--tappable-size-lg);
  padding-left: var(--spacing-md);
  gap: var(--spacing-sm);
`

const BackButton = styled.button`
  cursor: pointer;
`

type SidebarHeaderProps = {
  children: React.ReactNode
  onBack: MouseEventHandler
}

const SidebarHeader = ({ children, onBack }: SidebarHeaderProps) => {
  return (
    <HeaderContainer>
      <StyledHeader>
        <BackButton onClick={onBack}>
          <Icon size="lg" svg={<ChevronLeft />} />
        </BackButton>
        <Text font="heading-2">{children}</Text>
      </StyledHeader>
    </HeaderContainer>
  )
}

export default SidebarHeader
